import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { ChevronDownIcon } from '../Icons';
import { StyledIconWrap, StyledDownIconWrap, StyledHandle, StyledHandleContent } from './styled';
import { tokens } from './tokens';
import { SelectSize, SelectVariants } from './types';
export const SelectHandle = /*#__PURE__*/ forwardRef(({ size = SelectSize.m, icon, iconPlacement = 'left', children, showDownIcon = true, disabled, variant = SelectVariants.primary, ...restProps }, ref)=>{
    return /*#__PURE__*/ _jsxs(StyledHandle, {
        ...restProps,
        ref: ref,
        direction: "horizontal",
        alignY: "center",
        gap: tokens.Trigger.sizes[size].gap,
        size: size,
        tabIndex: 0,
        disabled: disabled,
        variant: variant,
        children: [
            icon && /*#__PURE__*/ _jsx(StyledIconWrap, {
                size: size,
                placement: iconPlacement,
                children: icon
            }),
            /*#__PURE__*/ _jsx(StyledHandleContent, {
                grow: "1",
                children: children
            }),
            showDownIcon && /*#__PURE__*/ _jsx(StyledDownIconWrap, {
                size: size,
                variant: variant,
                children: /*#__PURE__*/ _jsx(ChevronDownIcon, {
                    type: "default"
                })
            })
        ]
    });
});
